export default __webpack_public_path__ + "static/media/pin-typ-default.14bfb36a.svg";